import * as _ from 'lodash';
import { IListItem, IPhoneNumberForEdit } from "@nkr/models/index";
import { PhoneNumberTableWrapper } from '../styles';
import PhoneNumberListRow from "./list-row";
import PhoneNumberAddEdit from "./add-edit";

interface IProps {
    contactId: number,
    phoneNumbers: IPhoneNumberForEdit[],
    phoneTypes: IListItem[],
    mobileProviders: IListItem[],
    showMobileProvider: boolean,
    viewOnly: boolean,
    onChange: (list: IPhoneNumberForEdit[]) => void
}

const PhoneNumberList = (props: IProps) => {
    const allowAdd = props.phoneNumbers.filter(x => x.edit).length == 0;

    const handleEdit = (id: number) => {
        let phoneNumbers = _.cloneDeep(props.phoneNumbers).map(pn => {
            if (pn.id == id) {
                pn.edit = true;
            }

            return pn;
        });

        props.onChange(phoneNumbers);
    }

    const handleCancelEdit = () => {
        let phoneNumbers = _.cloneDeep(props.phoneNumbers).map(pn => {
            pn.edit = false;
            return pn;
        });

        props.onChange(phoneNumbers);
    }

    const handleDelete = (id: number) => {
        let phoneNumbers = _.cloneDeep(props.phoneNumbers);

        if (id > 0) {
            phoneNumbers = _.cloneDeep(props.phoneNumbers).map(pn => {
                if (pn.id == id) {
                    pn.isDeleted = true;
                }

                return pn;
            });
        } else {
            phoneNumbers = phoneNumbers.filter(x => x.id != id);
        }

        props.onChange(phoneNumbers);
    }

    const handleUndelete = (id: number) => {
        let phoneNumbers = _.cloneDeep(props.phoneNumbers).map(pn => {
            if (pn.id == id)
                pn.isDeleted = false;

            return pn;
        });

        props.onChange(phoneNumbers);
    }

    const handleAdd = (phoneTypeId: number, phoneNumber: string, mobileProviderId: number) => {
        let phoneNumbers = _.cloneDeep(props.phoneNumbers);

        let nextId = phoneNumbers.length > 0 ? (_.min(phoneNumbers.map(x => x.id)) > 0 ? 0 : _.min(phoneNumbers.map(x => x.id)) - 1) : 0;

        let phoneType = props.phoneTypes.find(x => x.id == phoneTypeId);

        let mobileProvider = props.mobileProviders.find(x => x.id == mobileProviderId);
        let mobileProviderName = mobileProvider ? mobileProvider.description : '';

        phoneNumbers.push({
            id: nextId - 1,
            isDeleted: false,
            phoneTypeId,
            phoneTypeName: phoneType.description,
            number: phoneNumber,
            mobileProviderId,
            mobileProviderName,
            contactId: props.contactId,
            edit: false
        });

        props.onChange(phoneNumbers);
    }

    const handleUpdate = (id: number, phoneTypeId: number, number: string, mobileProviderId: number) => {
        let phoneNumbers = _.cloneDeep(props.phoneNumbers);
        let phoneNumber = phoneNumbers.find(x => x.id == id);

        let phoneType = props.phoneTypes.find(x => x.id == phoneTypeId);

        let mobileProvider = props.mobileProviders.find(x => x.id == mobileProviderId);
        let mobileProviderName = mobileProvider ? mobileProvider.description : '';

        phoneNumber.phoneTypeId = phoneTypeId;
        phoneNumber.phoneTypeName = phoneType.description;
        phoneNumber.number = number;
        phoneNumber.mobileProviderId = mobileProviderId;
        phoneNumber.mobileProviderName = mobileProviderName;
        phoneNumber.edit = false;

        props.onChange(phoneNumbers);
    }

    return (
        <PhoneNumberTableWrapper condensed bordered>
            <thead>
                <tr>
                    <th style={{ width: '20%' }}>Type</th>
                    <th style={{ width: props.showMobileProvider ? '28%' : '57%' }}>Number</th>

                    {props.showMobileProvider && (
                        <th style={{ width: '27%' }}>Mobile Provider</th>
                    )}

                    {!props.viewOnly && (
                        <th></th>
                    )}
                </tr>
            </thead>
            <tbody>
                {props.phoneNumbers.map((phoneNumber, index) => {
                    if (phoneNumber.edit == false) {
                        return (
                            <PhoneNumberListRow
                                key={'ph-' + index}
                                data={phoneNumber}
                                showMobileProvider={props.showMobileProvider}
                                viewOnly={props.viewOnly}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                                onUndelete={handleUndelete}
                            />
                        );
                    } else {
                        return (
                            <PhoneNumberAddEdit
                                key={'ph-' + index}
                                data={phoneNumber}
                                showMobileProvider={props.showMobileProvider}
                                phoneTypes={props.phoneTypes}
                                mobileProviders={props.mobileProviders}
                                onAdd={handleAdd}
                                onUpdate={handleUpdate}
                                onCancelEdit={handleCancelEdit}
                            />
                        );
                    }
                })}

                {allowAdd && props.viewOnly == false && (
                    <PhoneNumberAddEdit
                        data={null}
                        showMobileProvider={props.showMobileProvider}
                        phoneTypes={props.phoneTypes}
                        mobileProviders={props.mobileProviders}
                        onAdd={handleAdd}
                        onUpdate={handleUpdate}
                        onCancelEdit={handleCancelEdit}
                    />
                )}
            </tbody>
        </PhoneNumberTableWrapper>
    );
}

export default PhoneNumberList;